import combineReducers from 'combine-reducers';
import reducers from '../reducers';
import { type State, type Store, type ChangeListener, type Unsubscribe } from '../types/store';
import type { UnknownAction } from '../types/actions';

type Reducer<T, A = UnknownAction> = (state: T, action: A) => T;

class DefaultStore implements Store<State> {
  private state: State;
  private listeners: ChangeListener[];
  private readonly reducer: Reducer<State>;

  constructor() {
    // eslint-disable-next-line yola/@typescript-eslint/no-unsafe-assignment
    this.reducer = combineReducers(reducers);
    this.state = this.reducer({} as State, {} as UnknownAction);
    this.listeners = [];
  }

  getState(): State {
    return this.state;
  }

  dispatch<T extends UnknownAction>(action: T): T {
    const initialState = this.state;

    this.state = this.reducer(this.state, action);

    if (initialState !== this.state) {
      this.emitChange();
    }

    return action;
  }

  subscribe(callback: ChangeListener): Unsubscribe {
    this.listeners.push(callback);

    return () => {
      this.listeners = this.listeners.filter((listener) => listener !== callback);
    };
  }

  private emitChange(): void {
    this.listeners.forEach((callback) => {
      callback();
    });
  }
}

export default DefaultStore;
